/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Petty_White_Deer_SlurpInputs */

const es_petty_white_deer_slurp = /** @type {(inputs: Petty_White_Deer_SlurpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te iremos contando las novedades de Zarpar.`)
};

const gl_petty_white_deer_slurp = /** @type {(inputs: Petty_White_Deer_SlurpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manterémosvos informados sobre Zarpar.`)
};

const en_petty_white_deer_slurp = /** @type {(inputs: Petty_White_Deer_SlurpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll keep you updated on Zarpar.`)
};

/**
* | output |
* | --- |
* | "We'll keep you updated on Zarpar." |
*
* @param {Petty_White_Deer_SlurpInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const petty_white_deer_slurp = /** @type {((inputs?: Petty_White_Deer_SlurpInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Petty_White_Deer_SlurpInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_petty_white_deer_slurp(inputs)
	if (locale === "en") return en_petty_white_deer_slurp(inputs)
	return es_petty_white_deer_slurp(inputs)
});